import type { UiLocale } from '../i18n/strings.ts';

/**
 * Mobile Settings → documentation opens the **Mobile** guide (not desktop Quick Start).
 * Path matches Docusaurus: `website/docs/docs/mobile.md` → `/docs/docs/mobile`.
 */
export const MOBILE_DOCS_PATH = 'docs/docs/mobile';

/** @deprecated Kept for callers that still pass a slug; mobile always uses {@link MOBILE_DOCS_PATH}. */
export const MOBILE_DOCS_SLUG = 'rikosub';

/**
 * User-facing docs URL for the mobile web app.
 */
export function buildDocumentationUrl(
  locale: UiLocale | string,
  _docsSlug: string = MOBILE_DOCS_SLUG,
): string {
  const lang = String(locale || 'en');
  if (lang === 'zh-TW' || lang.toLowerCase().startsWith('zh-tw')) {
    return `https://netflixsubs.app/zh-tw/${MOBILE_DOCS_PATH}`;
  }
  if (lang === 'zh-CN' || lang.toLowerCase().startsWith('zh-cn') || lang.toLowerCase() === 'zh') {
    return `https://netflixsubs.app/zh/${MOBILE_DOCS_PATH}`;
  }
  return `https://netflixsubs.app/${MOBILE_DOCS_PATH}`;
}
